import http from '../../../Utils/http';

const FetchAccountManager = {
  name: 'fetchAccountManager',
  state: {
    loading: false,
    error: '',
    details: null,
  },
  reducers: {
    fetchRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },
    fetchReceived(state, payload) {
      return {
        ...state,
        loading: false,
        details: payload,
        error: '',
      };
    },
    fetchFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
        details: null,
      };
    },
    clearData(state) {
      return {
        ...state,
        loading: false,
        error: '',
        details: null,
      };
    },
  },
  effects: () => ({
    async fetchAccountManager(orgId) {
      try {
        this.fetchRequested();
        const response = await http.get(
          `savvy/organization/accountManager/${orgId}`
        );
        this.fetchReceived(response?.data?.data ?? null);
      } catch (err) {
        const errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Failed to load account manager details';
        this.fetchFailed(errorMessage);
      }
    },
    clearAccountManager() {
      this.clearData();
    },
  }),
};

export default FetchAccountManager;
